import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=171c42c8&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=171c42c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171c42c8",
  null
  
)

export default component.exports